<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      show-date
      :product-options="['oem', 'fleet', 'dispenser']"
      date-option-type="datetime"
      :filter-names="filterNames"
      search-label="search"
      vertical-scroll
      :is-downloading="isDownload"
      :export-options="['csv', 'excel']"
      @isExport="downloadFile"
      @filterOption="onFiltersChange"
    >
      <template v-slot:nozzle_number="{ item }">
        <div class="">
          {{ item.display_name || item.nozzle_number }}
        </div>
      </template>
      <template v-slot:updated_at="{ item }">
        <div :class="item?.updated_at ? 'updatedRow' : ''">
          {{ item.updated_at }}
        </div>
      </template>
      <template v-slot:actions="{ item }">
        <v-icon
          v-if="isView"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-eye
        </v-icon>
        <v-icon
          v-if="isEdit"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="isDelete"
          class="mr-2"
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>

      <!-- add Filters -->
      <template #addFilters>
        <v-card>
          <v-select
            v-model="customFilters.terminal_id"
            filled
            dense
            clearable
            :items="terminalList"
            item-value="id"
            item-text="name"
            :label="$t('terminal')"
            @change="onTerminalChange"
          />
        </v-card>
        <v-card>
          <v-select
            v-model="customFilters.dispenser_id"
            filled
            dense
            clearable
            :items="dispenserList"
            item-value="id"
            item-text="dispenser_identifier"
            :label="$t('dispenser')"
            @change="onDispenserChange"
          />
        </v-card>
        <v-card>
          <v-select
            v-model="customFilters.nozzle_id"
            filled
            dense
            clearable
            :items="nozzleList"
            item-value="id"
            :item-text="(n) => n.display_name || n.nozzle_number"
            :label="$t('nozzle_number')"
            @change="fetchData"
          />
        </v-card>
        <v-card>
          <v-select
            v-model="customFilters.bus_no"
            filled
            dense
            clearable
            :items="busNoList"
            :label="$t('bus_no')"
            multiple
            @change="fetchData"
          >
            <template v-slot:selection="data">
              <span
                v-if="data.index === 0"
                class="selected"
              >
                <span>{{ data.item }}</span>
              </span>
              <span
                v-if="data.index === 1"
                class="grey--text text-caption"
              >
                (+{{ customFilters?.bus_no.length - 1 }} others)
              </span>
            </template>
          </v-select>
        </v-card>
      </template>
      <!-- add Filters -->

      <!-- Action Modals -->
      <template #actionModals>
        <div class="d-flex">
          <router-link
            v-if="options.tenant_id || options.fleetId"
            :to="goTo('data_logs_create')"
          >
            <v-btn
              color="primary"
              class="mx-0"
            >
              Add New Data Logs
            </v-btn>
          </router-link>
          <!--  -->
          <edit-data-logs
            v-if="(isView || isEdit) && editModal"
            :is-visible-dialog="editModal"
            :toggle-edit="toggleEditModal"
            :options="options"
            :item="selectedRow"
          />
          <confirmation-modal
            v-if="isDelete"
            :is-visible="deleteModal"
            :toggle="toggleDeleteModal"
            :row="selectedRow"
          />
        </div>
      </template>
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { debounce } from "lodash";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    EditDataLogs: () => import("./dialogs/EditDataLogs.vue"),
    ConfirmationModal: () =>
      import("@/components/Modals/ConfirmationModal.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      // module_name: "csmsChargeStations", //vuex module name which define in Store Index
      permissions: {
        view: "",
        create: "dispensers.list",
        edit: "dispensers.list",
        delete: "dispensers.list",
      },

      //
      customFilters: {},

      filters: {},
      subFilters: {},

      //
      nozzleList: [],
      //
      isDownload: false,
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "dataLogs/getLoading",
      meta: "dataLogs/getMeta",
      list: "dataLogs/getList",
      //
      terminalList: "terminal/getTerminalDropDown",
      dispenserList: "fuelDispenser/getList",
      busNoList: "dataLogs/getBusList",
    }),

    _headers() {
      const headers = [
        {
          text: this.$t("date"),
          align: "left",
          sortable: true,
          value: "date",
        },
        {
          text: this.$t("bus_no"),
          align: "left",
          sortable: false,
          value: "bus_no",
        },
        {
          text: this.$t("filling_time"),
          align: "left",
          sortable: true,
          value: "filling_time",
        },
        {
          text: this.$t("reg_no"),
          align: "left",
          sortable: false,
          value: "reg_no",
        },
        {
          text: this.$t("terminal"),
          align: "left",
          sortable: false,
          value: "terminal_name",
        },
        {
          text: this.$t("dispenser"),
          align: "left",
          sortable: false,
          value: "dispenser_name",
        },
        {
          text: this.$t("nozzle"),
          align: "left",
          sortable: true,
          value: "nozzle_number",
        },
        {
          text: this.$t("total_diesel"),
          align: "left",
          sortable: true,
          value: "total_diesel",
        },
        {
          text: this.$t("updated_at"),
          align: "left",
          sortable: true,
          value: "updated_at",
        },
        this.isEdit || this.isDelete || this.isView
          ? {
              text: this.$t("actions"),
              align: "left",
              sortable: false,
              value: "actions",
            }
          : {},
      ];
      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      // if (this.authUser.isAdmin) {
      //   return ["make_type"];
      // } else {
      return [""];
      // }
    },
  },
  watch: {
    "options.tenant_id": {
      handler: function (v) {
        if (v) {
          this.$store.dispatch("terminal/dropDownList", { tenant_id: v });
        } else {
          this.$store.commit("terminal/SET_LIST_DROPDOWN", []);
          this.$store.commit("fuelDispenser/SET_LIST", []);

          this.customFilters = {};
        }
      },
    },
    "options.fleetId": {
      handler: function (v) {
        if (v) {
          this.$store.dispatch("terminal/dropDownList", { tenant_id: v });
        } else {
          this.$store.commit("terminal/SET_LIST_DROPDOWN", []);
          this.$store.commit("fuelDispenser/SET_LIST", []);

          this.customFilters = {};
        }
      },
    },
    options() {
      this.fetchData();
    },
  },
  async mounted() {
    if (!this.authUser.isAdmin) {
      const tId = this.authUser?.independent_fleet_user_nature
        ? this.authUser.tenant_id
        : this.authUser.parent_tenant_id;
      const params = { tenant_id: tId };
      await this.$store.dispatch("terminal/dropDownList", params);
    }

    if (this.$route?.query?.terminal_id) {
      this.customFilters.terminal_id = parseInt(this.$route.query.terminal_id);
      await this.onTerminalChange(this.customFilters.terminal_id);
    }
    if (this.$route?.query?.dispenser_id) {
      this.customFilters.dispenser_id = parseInt(
        this.$route.query.dispenser_id
      );
      await this.onDispenserChange(this.customFilters.dispenser_id);
    }
    if (this.$route?.query?.nozzle_id) {
      this.customFilters.nozzle_id = parseInt(this.$route.query.nozzle_id);
    }
    if (this.$route?.query?.bus_no) {
      this.customFilters.bus_no = this.$route.query.bus_no;
    }
    this.fetchData();
  },
  beforeDestroy() {
    const params = {
      name: "data_logs",
      filters: { ...this.options, ...this.customFilters },
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    fetchData: debounce(async function () {
      const params = { ...this.options, ...this.customFilters };
      await this.$store.dispatch("dataLogs/list", params).then(() => {
        if (this.options.page > (this.meta?.lastPage || 1)) {
          this.options.page = 1;
        }
      });
    }, 1500),

    //
    async onTerminalChange(v) {
      delete this.customFilters.dispenser_id;
      delete this.customFilters.nozzle_id;
      if (v) {
        const params = { terminal_id: v };
        await this.$store.dispatch("fuelDispenser/list", params);
      } else {
        this.$store.commit("fuelDispenser/SET_LIST", []);
      }
      this.fetchData();
    },
    async onDispenserChange(v) {
      delete this.customFilters.nozzle_id;
      if (v) {
        const dRow = this.dispenserList.find((r) => r.id === v);
        this.nozzleList = dRow?.nozzles;
        await this.$store.dispatch(
          "dataLogs/busNoDropdown",
          this.customFilters
        );
      } else {
        this.$store.commit("dataLogs/SET_BUS_LIST", []);
        this.nozzleList = [];
      }
      this.fetchData(v);
    },

    async downloadFile(v) {
      this.isDownload = true;
      const params = { ...this.options, ...this.customFilters };

      await this.$store
        .dispatch("dataLogs/exportList", params)
        .then((res) => {
          if (v == "csv") {
            window.open(res.csv, "_blank");
          } else if (v == "excel") {
            window.open(res.excel, "_blank");
          }
        })
        .finally(() => (this.isDownload = false));
    },
    //
    goTo(path) {
      const params = { ...this.options, ...this.customFilters };
      if (params.dateType === "custom") {
        params.dateRange = params.date;
        delete params.date;
      }
      return { name: path, query: params };
    },
    // Confirmation of Delete Row
    async deleteSelectedRow(row) {
      try {
        await this.$store.dispatch("dataLogs/destroy", row);
        this.$store.dispatch("alerts/success", this.$t("deleted_successfully"));
        if (this.list.length === 0 && this.meta.lastPage == this.options.page) {
          this.options.page -= 1; // Move to the previous page
        }
        this.toggleDeleteModal("close");
        this.fetchData();
      } catch (error) {
        this.$store.dispatch("alerts/error", error.response?.data?.message);
      }
    },
  },
};
</script>
<style scoped>
:deep tr:has(td > div.updatedRow) {
  background: #ffe1e1 !important;
  /* A light blue, adjust as needed */
  /* Or a different color, for example: */
  /* background-color: #fffacd; Yellow */
  /* background-color: #f2f2f2; Light Gray */
}
</style>
